import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { OTHER_NODES_LABEL } from "@faire/help-center-self-serve/shared/other-node";
import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useAssignSettingSelfServeBrandInstantAnswers, useSettingSelfServeBrandInstantAnswers } from "@faire/help-center-utils/settings/useSettingSelfServiceBrandInstantAnswers";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Storefront } from "@faire/web--source/slate/icons/foundation/Storefront";
import React from "react";
export var useMyShopBrandNodes = function useMyShopBrandNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var enableSettingSelfServeBrandInstantAnswers = useSettingSelfServeBrandInstantAnswers();
  var assignSettingSelfServeBrandInstantAnswers = useAssignSettingSelfServeBrandInstantAnswers();
  var articles = useArticles();
  var commonFields = {
    id: "MyShop",
    label: strictLocalize({
      id: "p4WAW6",
      defaultMessage: [{
        "type": 0,
        "value": "Winkel beheren"
      }]
    }),
    icon: /*#__PURE__*/React.createElement(Storefront, {
      fontSize: "24px",
      color: "faireBlack"
    }),
    level: 1,
    assignSetting: assignSettingSelfServeBrandInstantAnswers,
    sidebarTitle: strictLocalize({
      id: "GZDCqb",
      defaultMessage: [{
        "type": 0,
        "value": "Winkelprobleem"
      }]
    })
  };
  if (!enableSettingSelfServeBrandInstantAnswers) {
    return {
      MyShop: _objectSpread(_objectSpread({}, commonFields), {}, {
        children: ["Settings", "OtherMyShop"]
      }),
      Settings: {
        id: "Settings",
        label: strictLocalize({
          id: "iyytHb",
          defaultMessage: [{
            "type": 0,
            "value": "Instellingen"
          }]
        }),
        level: 2
      },
      OtherMyShop: {
        id: "OtherMyShop",
        label: OTHER_NODES_LABEL(strictLocalize),
        articles: [articles.OptimizingMyPage.PRODUCT_PHOTOGRAPHY_GUIDELINES, articles.OptimizingMyPage.BRAND_STORY_GUIDELINES, articles.OptimizingMyPage.ADD_VIDEO],
        level: 2
      }
    };
  }
  return {
    MyShop: _objectSpread(_objectSpread({}, commonFields), {}, {
      children: ["Analytics", "CustomerReviews", "ShopPage", "ShopPreferences"],
      shouldStopAddingDefaultOtherNodeToChildren: true
    }),
    Analytics: {
      id: "Analytics",
      label: strictLocalize({
        id: "Hwxr4e",
        defaultMessage: [{
          "type": 0,
          "value": "Statistieken"
        }]
      }),
      children: ["AboutAnalytics", "CustomerServiceAnalytics"],
      level: 2
    },
    CustomerReviews: {
      id: "CustomerReviews",
      label: strictLocalize({
        id: "Bt+JGX",
        defaultMessage: [{
          "type": 0,
          "value": "Beoordelingen van klanten"
        }]
      }),
      children: ["RequestReview", "DisputeReview"],
      level: 2
    },
    ShopPage: {
      id: "ShopPage",
      label: strictLocalize({
        id: "6P1nVk",
        defaultMessage: [{
          "type": 0,
          "value": "Winkelpagina"
        }]
      }),
      children: ["ShopImagery", "ShopAboutSection"],
      level: 2
    },
    ShopPreferences: {
      id: "ShopPreferences",
      label: strictLocalize({
        id: "Npp87B",
        defaultMessage: [{
          "type": 0,
          "value": "Winkelvoorkeuren"
        }]
      }),
      children: ["OrderMinimums", "InternationalOrderSettings", "ScheduledOrders", "ShopLeadTime", "OnLineOnlyRetailers", "PauseShop"],
      level: 2
    },
    AboutAnalytics: {
      id: "AboutAnalytics",
      label: strictLocalize({
        id: "d62nEt",
        defaultMessage: [{
          "type": 0,
          "value": "Over analytics"
        }]
      }),
      level: 3
    },
    CustomerServiceAnalytics: {
      id: "CustomerServiceAnalytics",
      label: strictLocalize({
        id: "v1mc5n",
        defaultMessage: [{
          "type": 0,
          "value": "Analytics van klantenservice"
        }]
      }),
      level: 3
    },
    RequestReview: {
      id: "RequestReview",
      label: strictLocalize({
        id: "zY6+/H",
        defaultMessage: [{
          "type": 0,
          "value": "Een beoordeling aanvragen"
        }]
      }),
      level: 3
    },
    DisputeReview: {
      id: "DisputeReview",
      label: strictLocalize({
        id: "hnCNrA",
        defaultMessage: [{
          "type": 0,
          "value": "Een beoordeling betwisten"
        }]
      }),
      level: 3
    },
    ShopImagery: {
      id: "ShopImagery",
      label: strictLocalize({
        id: "7/2xqT",
        defaultMessage: [{
          "type": 0,
          "value": "Afbeeldingen op je winkelpagina"
        }]
      }),
      level: 3
    },
    ShopAboutSection: {
      id: "ShopAboutSection",
      label: strictLocalize({
        id: "RQFAOi",
        defaultMessage: [{
          "type": 0,
          "value": "Winkel over sectie"
        }]
      }),
      level: 3
    },
    OrderMinimums: {
      id: "OrderMinimums",
      label: strictLocalize({
        id: "HTW9ou",
        defaultMessage: [{
          "type": 0,
          "value": "Bestelminima"
        }]
      }),
      level: 3
    },
    InternationalOrderSettings: {
      id: "InternationalOrderSettings",
      label: strictLocalize({
        id: "qp8KdC",
        defaultMessage: [{
          "type": 0,
          "value": "Instellingen voor internationale bestellingen"
        }]
      }),
      level: 3
    },
    ScheduledOrders: {
      id: "ScheduledOrders",
      label: strictLocalize({
        id: "4OgJZK",
        defaultMessage: [{
          "type": 0,
          "value": "Geplande bestellingen"
        }]
      }),
      level: 3
    },
    ShopLeadTime: {
      id: "ShopLeadTime",
      label: strictLocalize({
        id: "Vb8AOc",
        defaultMessage: [{
          "type": 0,
          "value": "Doorlooptijd van winkel"
        }]
      }),
      level: 3
    },
    OnLineOnlyRetailers: {
      id: "OnLineOnlyRetailers",
      label: strictLocalize({
        id: "m9p2Er",
        defaultMessage: [{
          "type": 0,
          "value": "Uitsluitend online retailers"
        }]
      }),
      level: 3
    },
    PauseShop: {
      id: "PauseShop",
      label: strictLocalize({
        id: "lcnyyb",
        defaultMessage: [{
          "type": 0,
          "value": "Winkel pauzeren"
        }]
      }),
      level: 3
    }
  };
};